import React, { useState } from 'react';
import { motion } from 'framer-motion';

import ItemMobile from './ItemMobile';

const itemVariants = {
  closed: { opacity: 0 },
  open: { opacity: 1 },
};

const sideVariants = {
  closed: {
    transition: {
      staggerChildren: 0,
      staggerDirection: -1,
      duration: 0.1,
    },
  },
  open: {
    transition: {
      duration: 0.2,
    },
  },
};

function Item({ children }) {
  return (
    <motion.div variants={itemVariants} className={['  flex items-center'].join(' ')}>
      {children}
    </motion.div>
  );
}

export default function MobileMenuChild({ item, closeMenu }) {
  return (
    <div className="w-full h-full ">
      <motion.div className="container bg-white" initial="closed" animate="open" exit="closed" variants={sideVariants}>
        <div className="w-full h-fit flex flex-col">
          {/* {renderPagination} */}
          {item.children?.length > 0 &&
            item.children.map((itm) => (
              <Item key={itm.id} itm={item.title}>
                <ItemMobile itm={itm} closeMenu={closeMenu} />
              </Item>
            ))}
        </div>
      </motion.div>
    </div>
  );
}
